import React from 'react';
import { shape } from 'prop-types';

import { eventShape, celebrityInfoShape } from 'constants/propTypesShapes';
import {  useIsMobile } from 'hooks';
import EventPlayer from 'components/Players/VideoJs/EventPlayer';

const EventVideoPlayer = ({ authenticated, event, celebrity }) => {
  const isMobile = useIsMobile();


  return (
    <div
      className="slider-container"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        overflow: 'hidden'
      }}
    >
      <div
        className="slider-content"
        style={{
          position: 'relative',
          width: '100%',
          height: '100vh',
          maxWidth: isMobile ? '100vw' : '80vw',
          maxHeight: '100vh',
          borderRadius: '0',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100vh',
            flexGrow: undefined
          }}
        >
          <EventPlayer
            className="slide"
            indexId={`jwplayer-${event.id}`}
            event={event}
            play
            celebrity={celebrity}
            authenticated={authenticated}
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>
  );
};

EventVideoPlayer.propTypes = {
  event: shape(eventShape).isRequired,
  celebrity: shape(celebrityInfoShape)
};

export default EventVideoPlayer;
